import { render, staticRenderFns } from "./ClientOrdersTab.vue?vue&type=template&id=3b9742de"
import script from "./ClientOrdersTab.vue?vue&type=script&lang=js"
export * from "./ClientOrdersTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports